const langMap = {
	pl: 'pl-PL',
	en: 'en-US',
	de: 'de-DE',
	es: 'es-ES',
	cs: 'cs-CZ',
	sk: 'sk-SK',
}

export const locales = [
  { name: 'English', value: 'en-US' },
  { name: 'Polski', value: 'pl-PL' },
  { name: 'Deutsch', value: 'de-DE' },
  { name: 'Español', value: 'es-ES' },
  { name: 'Čeština', value: 'cs-CZ' },
  { name: 'Slovenčina', value: 'sk-SK' },
]
console.log('LangUtils loaded. Locales:', locales)

export function normalizeLang(lang) {
	if (!lang) return ''

	const normalized = lang.toLowerCase().replace(/([a-z]{2})-([a-z]{2})/, (p1, p2) => {
		return `${p1}-${p2.toUpperCase()}`
	})

	if (Object.values(langMap).includes(normalized)) return normalized

	const shortLang = normalized.split('-')[0]
	if (langMap[shortLang]) return langMap[shortLang]

	return ''
}

export const supportedLangs = Object.values(langMap)